import { useSelector } from 'react-redux';
import LinkAccountMenuItem from './LinkAccountMenuItem';
import SwitchAccountMenuItem from './SwitchAccountItem';

const LinkAccountController = ({ isMobile = false }) => {
  const linkedUser = useSelector(state => state.user.user?.linkedUser);

  if (linkedUser) {
    return <SwitchAccountMenuItem isMobile={isMobile} />;
  }

  return <LinkAccountMenuItem isMobile={isMobile} />;
};

export default LinkAccountController;
